(() => {
  'use strict';
  if (window.OleaPdpQuantity) return;
  window.OleaPdpQuantity = true;
  const normalize = input => {
    const min = Number(input.min || 1);
    const step = Number(input.step || 1);
    const max = Number(input.max || Infinity);
    const value = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
    input.value = String(min + Math.max(0, Math.floor((Math.min(max, value) - min) / step)) * step);
    const root = input.closest('.olea-pdp-main');
    root?.querySelectorAll('[data-sticky-quantity]').forEach(sticky => { sticky.value = input.value; });
    const controls = input.closest('.olea-pdp-main__quantity');
    const decrease = controls?.querySelector('[data-pdp-quantity-step="-1"]');
    const increase = controls?.querySelector('[data-pdp-quantity-step="1"]');
    if (decrease) decrease.disabled = Number(input.value) <= min;
    if (increase) increase.disabled = Number(input.value) + step > max;
  };
  const feedbackTimers = new WeakMap();
  const shareContext = button => {
    const root = button.closest('[data-product-section]');
    const url = new URL(root?.dataset.productUrl || location.pathname, location.origin);
    if (url.origin !== location.origin) return null;
    url.search = '';
    url.hash = '';
    const current = new URL(location.href);
    const variant = root?.dataset.variantId || current.searchParams.get('variant');
    if (variant) url.searchParams.set('variant', variant);
    const preview = current.searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const heading = root?.querySelector('h1')?.cloneNode(true);
    heading?.querySelectorAll('small').forEach(subtitle => subtitle.remove());
    return { url: url.href, title: heading?.textContent?.trim() || document.title };
  };
  const shareFeedback = (button, message) => {
    const wrapper = button.closest('.pdp-share');
    if (!wrapper?.isConnected || !message) return;
    const copy = wrapper.querySelector('[data-pdp-share-channel="copy"]');
    const label = copy?.querySelector('em');
    const original = wrapper.dataset.copyLabel || label?.textContent || '';
    const originalAria = copy?.getAttribute('aria-label');
    const pending = feedbackTimers.get(wrapper);
    if (pending) clearTimeout(pending.timer);
    const resetAria = pending ? pending.originalAria : originalAria;
    if (label) label.textContent = message;
    copy?.setAttribute('aria-label', message);
    const status = wrapper.querySelector('[data-pdp-share-status]');
    if (status) status.textContent = message;
    else window.Olea?.announce?.(message);
    const timer = setTimeout(() => {
      feedbackTimers.delete(wrapper);
      if (!wrapper.isConnected) return;
      if (label) label.textContent = original;
      if (copy) {
        if (resetAria == null) copy.removeAttribute('aria-label');
        else copy.setAttribute('aria-label', resetAria);
      }
      if (status) status.textContent = '';
    }, 1800);
    feedbackTimers.set(wrapper, { timer, originalAria: resetAria });
  };
  const copyShare = async (button, context, instagram = false) => {
    const wrapper = button.closest('.pdp-share');
    try {
      if (typeof window.Olea?.copyText === 'function') await window.Olea.copyText(context.url);
      else if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(context.url);
      else throw new Error('Clipboard unavailable');
      const message = instagram ? wrapper?.dataset.instagramCopiedLabel : wrapper?.dataset.copiedLabel;
      shareFeedback(button, message || window.Olea?.strings?.copied);
    } catch {
      shareFeedback(button, wrapper?.dataset.copyErrorLabel || window.Olea?.strings?.error);
    }
  };
  const shareProduct = async button => {
    const context = shareContext(button);
    if (!context) return;
    const channel = button.dataset.pdpShareChannel;
    const encodedTitle = encodeURIComponent(context.title);
    const encodedUrl = encodeURIComponent(context.url);
    if (channel === 'copy') return copyShare(button, context);
    if (channel === 'whatsapp') window.open('https://wa.me/?text=' + encodeURIComponent(context.title + ' ' + context.url), '_blank', 'noopener');
    else if (channel === 'x') window.open('https://twitter.com/intent/tweet?text=' + encodedTitle + '&url=' + encodedUrl, '_blank', 'noopener');
    else if (channel === 'facebook') window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl, '_blank', 'noopener');
    else if (channel === 'email') location.href = 'mailto:?subject=' + encodedTitle + '&body=' + encodedUrl;
    else if (channel === 'instagram') {
      const mobile = navigator.userAgentData?.mobile === true || window.matchMedia('(pointer: coarse)').matches;
      if (mobile && typeof navigator.share === 'function') {
        try { await navigator.share(context); }
        catch (error) { if (error.name !== 'AbortError') await copyShare(button, context, true); }
      } else await copyShare(button, context, true);
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.olea-pdp-main [data-pdp-quantity-step]');
    const share = event.target.closest('.olea-pdp-main [data-pdp-share-channel]');
    if (share) {
      event.preventDefault();
      void shareProduct(share);
      return;
    }
    if (!button) return;
    const input = button.closest('.olea-pdp-main__quantity')?.querySelector('[data-product-quantity]');
    if (!input) return;
    const amount = Number(button.dataset.pdpQuantityStep);
    normalize(input);
    if (amount > 0) input.stepUp();
    else input.stepDown();
    normalize(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('.olea-pdp-main [data-product-quantity]')) normalize(event.target);
  });
  const initialize = () => document.querySelectorAll('.olea-pdp-main [data-product-quantity]').forEach(normalize);
  document.addEventListener('olea:variant-change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
